/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { SalesTerritoryAssignmentDtoModel, TerritorySalesListVoModel } from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class SalesTerritoryAssignmentResourceService extends AbstractResourceService<TerritorySalesListVoModel,
  SalesTerritoryAssignmentDtoModel,
  undefined,
  undefined> {
  constructor(protected httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('salesTerritoryUrl'),
      TerritorySalesListVoModel,
      SalesTerritoryAssignmentDtoModel,
      undefined,
      undefined
    );
  }

  patchSales(uuid: any, patch: boolean) {
    return this.httpClient.patch(`${this.url}/${uuid}`, patch, { headers: this.headers})
  }
}
